module.exports = __webpack_public_path__ + "static/media/bg_img_bottom.ff66470f.png";